import httpClient from '@/http-client'
export const get = (Options = {}) => {
  return httpClient
    .get('/api/v1/restaurant-sales/counter-checkouts', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const store = data => {
  return httpClient
    .post('/api/v1/restaurant-sales/counter-checkouts', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const destroy = (id, data) => {
  return httpClient
    .put(`/api/v1/restaurant-sales/counter-checkouts/delete/${id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const getTable = (Options = {}) => {
  return httpClient
    .get('/api/v1/restaurant-sales/counter-checkouts/tables', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const combineTable = (Options = {}) => {
  return httpClient
    .get('/api/v1/restaurant-sales/counter-checkouts/combine-tables', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const moveTable = (Options = {}) => {
  return httpClient
    .get('/api/v1/restaurant-sales/counter-checkouts/move-tables', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const cleanTable = (Options = {}) => {
  return httpClient
    .get('/api/v1/restaurant-sales/counter-checkouts/clean-tables', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const isCustomerCome = (Options = {}) => {
  return httpClient
    .get(
      '/api/v1/restaurant-sales/counter-checkouts/is-customer-comes',
      Options
    )
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const shiftClose = data => {
  return httpClient
    .post('/api/v1/restaurant-sales/counter-checkouts/shift-close', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const printPDF = (id, Options = {}) => {
  return httpClient
    .get(`/api/v1/restaurant-sales/counter-checkouts/generate-pdf/${id}`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const printBill = (Options = {}) => {
  return httpClient
    .get('/api/v1/restaurant-sales/counter-checkouts/print-bills', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const paymentMethod = (Option = {}) => {
  return httpClient
    .get('/api/v1/restaurant-sales/payment-methods', Option)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const bankProfile = () => {
  return httpClient
    .get('/api/v1/restaurant-sales/bank-profiles')
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const cancelOrder = (stock_out_id, data) => {
  return httpClient
    .put(`/api/v1/restaurant-sales/counter-checkouts/cancel-order/${stock_out_id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const linkedKey = data => {
  return httpClient
    .post('/api/v1/restaurant-sales/linked-keys', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const remarks = () => {
  return httpClient
    .get('/api/v1/restaurant-sales/remarks')
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getCustomerMemberCard = (Options = {}) => {
  return httpClient
    .get('/api/v1/restaurant-sales/counter-checkouts/customer-member-cards', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const serviceDurationDetail = data => {
  return httpClient
    .post('/api/v1/restaurant-sales/service-duration-details', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getFloating = (Options = {}) => {
  return httpClient
    .get('/api/v1/restaurant-sales/counter-checkouts/floatings', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default {
  get,
  store,
  destroy,
  getTable,
  combineTable,
  moveTable,
  cleanTable,
  isCustomerCome,
  shiftClose,
  printPDF,
  printBill,
  paymentMethod,
  bankProfile,
  cancelOrder,
  linkedKey,
  remarks,
  getCustomerMemberCard,
  serviceDurationDetail,
  getFloating
}
